(function($) {
  function productTabs() {
    $(document).on('click', '.tabs-content .technical-info a[href*="#IFRA"]', function(e) {
      e.preventDefault();
      
      $.fancybox.open({
        src  : '.tabs-content .technical-info table',
        type : 'inline',
        opts : {
          beforeShow: function( instance, current ) {
            $('.tabs-content .technical-info table').addClass('table-ifra-guidelines');
          }
        }
      });      
    });
  }
  
  function addSampleToCart() {
    $(document).on('click', '.add_sample_to_cart', function (e) {
      e.preventDefault();
      const $addToCartBtn = $(e.currentTarget);
      const variant_id = $addToCartBtn.data('variant-id');
      const data = {
        items: [
          {
            id: variant_id,
            quantity: 1
          }
        ]
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: data,
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          $addToCartBtn.prop('disabled', true);

          window.setTimeout(() => {
            //$addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('span').text('Free Sample Added');
            //$addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }
              }, 500);
            },
          });
        },
        error(XMLHttpRequest) {
          let response = eval(`(${XMLHttpRequest.responseText})`);
          response = response.description;
          $('.warning').remove();

          const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
    });    
  }
  
  function responsiveTable() {
      if ($('div.rte > table').length > 0) {
          $('div.rte > table').each(function() {
              if ($(this).find('tr:first-child td').length > 2) {
                  $(this).wrap('<div class="table-responsive"></div>');
              }
          })
      }      
  }
  
  $(document).ready(function() {
    productTabs();
    addSampleToCart();
    responsiveTable();
  });
})(jQuery);
/* ============================================================
   STOCK FRAGRANCE — Product video background
   Restores the "video plays in place of the image" feature.
   Reads the video URL stored in the primary product image's
   alt text (format:  "image description; https://.../file.mp4")
   and plays it FULL-WIDTH, with the product details floating
   over it. Products WITHOUT a video URL are left untouched.
   Paste this at the very END of assets/custom.js.liquid
   ============================================================ */
(function () {
  function initProductVideo() {
    var section = document.querySelector('.product_section');
    var imgCol = document.querySelector('.product__images');
    if (!section || !imgCol) return;                       // not a product page
    if (document.querySelector('.sf-product-video')) return; // already injected

    var primary = imgCol.querySelector('img');
    if (!primary) return;

    // Pull the video URL out of the alt text (a .mp4 or /videos/ link)
    var alt = primary.getAttribute('alt') || '';
    var url = alt.split(';')
      .map(function (s) { return s.trim(); })
      .find(function (p) { return /^https?:\/\/.*(\/videos\/|\.mp4)/i.test(p); });

    if (!url) return;   // no video on this product -> leave the normal gallery alone

    // Flag the page so the video layout CSS turns on
    document.body.classList.add('product-has-video');

    // Build the full-width video
    var wrap = document.createElement('div');
    wrap.className = 'custom-full-width video-background sf-product-video';

    var video = document.createElement('video');
    video.autoplay = true;
    video.muted = true;                 // required for autoplay
    video.loop = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'auto');

    var source = document.createElement('source');
    source.src = url;
    source.type = 'video/mp4';

    video.appendChild(source);
    wrap.appendChild(video);

    // Insert into the CENTERED product section (as the first item) so the
    // full-bleed 100vw math lands on the page centre, not the image column.
    section.insertBefore(wrap, section.firstChild);

    video.play().catch(function () {});  // some browsers need an explicit play()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductVideo);
  } else {
    initProductVideo();
  }
})();
/* ============================================================
   STOCK FRAGRANCE — AI guide purchase attribution (2026-08-05,
   widened 2026-08-28 for OI-67: collection/search quick-adds)
   The AI guide stores every product it cards in localStorage
   (key sfAiCarded, 7-day expiry, product handles only — no
   shopper identity). A cart-add form for a carded oil gains a
   hidden properties[_ai_guide]=yes input — the same line
   property the card's own Add-to-Cart button sets — WHEREVER
   the form lives:
   - product pages: unchanged proven behavior (every cart-add
     form on a carded oil's page is tagged);
   - collection grids / search / any other page: each quick-add
     form is matched to its own product via the single distinct
     /products/ link inside its product-card ancestor, and
     tagged only if THAT product was carded. If an ancestor
     holds links to several different products we have climbed
     past the card into the grid — that form is left untagged
     rather than guessed at.
   Safe no-op for shoppers who never used the guide.
   Paste this at the very END of assets/custom.js.liquid
   ============================================================ */
(function () {
  var list;
  try { list = JSON.parse(localStorage.getItem('sfAiCarded') || '[]'); } catch (e) { return; }
  var now = Date.now();
  var carded = {};
  var any = false;
  for (var i = 0; i < list.length; i++) {
    var e = list[i];
    if (e && e.h && (now - e.ts) < 7 * 24 * 3600 * 1000) {
      carded[String(e.h).toLowerCase()] = true;
      any = true;
    }
  }
  if (!any) return; // guide never carded anything (or all entries expired)

  var pm = location.pathname.match(/\/products\/([a-z0-9][a-z0-9\-]*)/i);
  var pageHandle = pm ? pm[1].toLowerCase() : null;
  var pageCarded = !!(pageHandle && carded[pageHandle]);

  function handleFromLink(a) {
    var href = a.getAttribute('href') || '';
    var m = href.match(/\/products\/([a-z0-9][a-z0-9\-]*)/i);
    return m ? m[1].toLowerCase() : null;
  }

  // Which product does this quick-add form add? Climb from the form to the
  // first ancestor containing /products/ links; exactly one distinct handle
  // means we found the product card. Several distinct handles means we're
  // at grid level — give up on this form instead of guessing.
  function formHandle(f) {
    var node = f;
    for (var depth = 0; node && node !== document.body && depth < 8; depth++) {
      if (node.querySelectorAll) {
        var links = node.querySelectorAll('a[href*="/products/"]');
        if (links.length) {
          var found = null;
          for (var j = 0; j < links.length; j++) {
            var h = handleFromLink(links[j]);
            if (!h) continue;
            if (found && found !== h) return null; // grid level — ambiguous
            found = h;
          }
          if (found) return found;
        }
      }
      node = node.parentNode;
    }
    return null;
  }

  function shouldTag(f) {
    if (pageHandle) return pageCarded; // product page: proven 08-05 behavior
    var h = formHandle(f);
    return !!(h && carded[h]);
  }

  function tagForm(f) {
    if (!f || f.querySelector('input[name="properties[_ai_guide]"]')) return;
    if (!shouldTag(f)) return;
    var inp = document.createElement('input');
    inp.type = 'hidden';
    inp.name = 'properties[_ai_guide]';
    inp.value = 'yes';
    f.appendChild(inp);
  }
  function tagAll() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) tagForm(forms[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagAll);
  } else {
    tagAll();
  }
  // Late-rendered forms (quick shop, app blocks, infinite scroll): tag at
  // submit time too. Capture phase runs before the theme's AJAX handlers
  // serialize the form.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) tagForm(f);
  }, true);
})();

/* ============================================================
   STOCK FRAGRANCE — AI guide attribution v3.2: cart attribute,
   SAME SESSION (task #47 v3 2026-09-05; v3.1 Nate 2026-09-18
   "ai assisted is per session, not over time"; v3.2 Nate
   2026-10-02 OI-102 option 3 "the cart decides"). The guide block
   records in localStorage that the guide was used THIS SESSION
   (key sfAiUsed: first use, last activity, up to 10 carded
   handles; no question text, no identity). A session ends after
   30 minutes with no page view — the standard analytics
   definition — and every page load here extends it. While the
   session is live this block copies the marker onto the CART —
   attributes ai_guide = "used YYYY-MM-DD" and ai_guide_cards =
   "handle,handle,…" — via one POST /cart/update.js, so an order
   placed in the same visit lands them as note attributes and
   Shopify Flow tags it AI-ASSISTED (AI-GUIDE alone if a line
   came from a guide card). When the session has LAPSED, the
   marker is dropped and the cart's attributes are cleared, so a
   cart built after a guide visit and bought days later is NOT
   tagged. Runs on every page load and immediately when the
   guide is used on this page (window.sfAiMarkCart, called by
   the guide block). v3.2: the CART decides, not the browser's
   memory — theme.liquid prints the cart's ai_guide attribute
   into window.sfAiCartAttr at render time (no extra request),
   and when the browser holds no live session but the cart still
   carries the attribute (Safari deletes a site's script storage
   after 7 days of use without a visit; the Shopify cart lives
   ~2 weeks and is refreshed by every addition — SF14027, 9/29,
   was credited to a 9/6 visit this way), the attribute is
   cleared. The marker is dropped only AFTER the cart update
   succeeds, so a failed clear is retried on the next page load
   instead of being lost. Safe no-op for shoppers who never used
   the guide, and when storage is blocked. Nothing is shown to
   the shopper: the cart template and order confirmation do not
   print these attributes (verified 2026-09-05).
   Paste this at the very END of assets/custom.js.liquid
   ============================================================ */
(function () {
  var USED_KEY = 'sfAiUsed', USED_TTL = 30 * 60 * 1000, DONE_KEY = 'sfAiCartMarked', CLEARED_KEY = 'sfAiCartCleared';
  var inFlight = false;

  function readRaw() {
    var u = null;
    try { u = JSON.parse(localStorage.getItem(USED_KEY) || 'null'); } catch (e) { return null; }
    if (!u || typeof u.first !== 'number') return null;
    if (typeof u.last !== 'number') u.last = u.first;
    return u;
  }
  function readUsed() { // live session only; a lapsed marker reads as null
    var u = readRaw();
    if (!u || (Date.now() - u.last) > USED_TTL) return null;
    return u;
  }
  function touch(u) { // a page view extends the session
    try { u.last = Date.now(); localStorage.setItem(USED_KEY, JSON.stringify(u)); } catch (e) { /* ignore */ }
  }
  function dropUsed() {
    try { localStorage.removeItem(USED_KEY); } catch (e) { /* ignore */ }
    try { sessionStorage.removeItem(DONE_KEY); } catch (e) { /* ignore */ }
  }
  function isoDay(ts) {
    try { return new Date(ts).toISOString().slice(0, 10); } catch (e) { return ''; }
  }
  function markDone(token) {
    try { sessionStorage.setItem(DONE_KEY, String(token || '1')); } catch (e) { /* ignore */ }
  }
  function alreadyDone() {
    try { return !!sessionStorage.getItem(DONE_KEY); } catch (e) { return false; }
  }
  function postAttrs(payload, onOk) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json', 'accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { if (r && r.ok && onOk) onOk(); inFlight = false; });
  }

  function markCart(force) {
    var u = readUsed();
    if (!u || inFlight) return;
    if (!force && alreadyDone()) return;
    inFlight = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) { inFlight = false; return; }
        var attrs = cart.attributes || {};
        var cards = Array.isArray(u.cards) ? u.cards.slice(0, 10).join(',') : '';
        var want = 'used ' + isoDay(u.first);
        if (attrs.ai_guide === want && (!cards || attrs.ai_guide_cards === cards)) { markDone(cart.token); inFlight = false; return; } // already on this cart, current
        var payload = { attributes: {} };
        if (attrs.ai_guide !== want) payload.attributes.ai_guide = want; // this session's date (a fresh session rewrites a stale one)
        if (cards && attrs.ai_guide_cards !== cards) payload.attributes.ai_guide_cards = cards; // cards render after the question — refresh the list
        return postAttrs(payload, function () { markDone(cart.token); });
      })
      .catch(function () { inFlight = false; });
  }

  // The session has lapsed (or the browser forgot it while the cart did not): take the
  // attributes OFF the cart so a later purchase from this cart is not credited to a guide
  // visit that ended. v3.2: the marker is dropped only once the cart is clean, so a failed
  // request leaves it in place and the next page load tries again.
  function clearCart() {
    if (inFlight) return;
    inFlight = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) { inFlight = false; return; }
        var attrs = cart.attributes || {};
        if (!attrs.ai_guide && !attrs.ai_guide_cards) { dropUsed(); inFlight = false; return; } // cart already clean
        return postAttrs({ attributes: { ai_guide: '', ai_guide_cards: '' } }, function () { dropUsed(); });
      })
      .catch(function () { inFlight = false; }); // marker kept → retried on the next page load
  }

  // The guide block calls this the moment a question is asked or a card
  // renders, so a shopper who asks and checks out from the same page is
  // covered without waiting for the next page load.
  window.sfAiMarkCart = function () { markCart(true); };

  var raw = readRaw();
  // v3.2: what the CART says, printed by theme.liquid at render time: the ai_guide attribute
  // ("used YYYY-MM-DD") or null. Undefined where the layout line is absent → the old behaviour.
  var cartAttr = (typeof window.sfAiCartAttr === 'string' && window.sfAiCartAttr) ? window.sfAiCartAttr : null;
  if (!raw) { if (cartAttr) clearCart(); return; } // no session in this browser — a marker still on the cart is stale → clear
  if ((Date.now() - raw.last) > USED_TTL) { clearCart(); return; } // lapsed → clear
  touch(raw); // live session, this page view extends it (a stale date on the cart is rewritten by markCart below)
  function later() { setTimeout(function () { markCart(false); }, 1500); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', later);
  } else {
    later();
  }
})();
